import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect } from 'react-router-dom';

import Toggle from 'react-toggle';
import InputMask from 'react-input-mask';
import Select from 'react-select';

import { Tabs, Tab, Modal } from 'react-bootstrap';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import {ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import getLocale from '../../i18n/getLocale';


class FatigueAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      simulated: 0,
      applicabilities_list: [],
      data: [],
      data_reports: null,
      key: 1,
      date_start_str: '',
      date_finish_str: '',
      quantity_points: '',
      modal: false,
    };

    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.add = this.add.bind(this);
    this.addFatigue = this.addFatigue.bind(this);
    this.copytoNextDate = this.copytoNextDate.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleChangeData (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleToggleChange (date_str, event) {
    var change = {};
    var data_temp = [];
    var data_temp_inputs = [];
    var self = this;
    Object.keys(self.state.data).map(function(date) {
      data_temp[date] = {};
      data_temp[date].date_str = self.state.data[date].date_str;
      data_temp[date].quantity_points = self.state.data[date].quantity_points;
      data_temp_inputs = [];
      if(self.state.data[date].date_str === date_str) {
        data_temp[date].day_off = event.target.checked;
      } else {
        data_temp[date].day_off = self.state.data[date].day_off;
      }
      Object.keys(self.state.data[date].inputs).map(function(info) {
        change = {
        value: self.state.data[date].inputs[info].value,
        id: self.state.data[date].inputs[info].id,
        name: self.state.data[date].inputs[info].name,
        type_str: self.state.data[date].inputs[info].type_str,
        type: self.state.data[date].inputs[info].type,
        fatigue_options: self.state.data[date].inputs[info].fatigue_options,
        operator: self.state.data[date].inputs[info].operator,
        hour_points: self.state.data[date].inputs[info].hour_points,
        quantity_points: self.state.data[date].inputs[info].quantity_points,
        point_limit: self.state.data[date].inputs[info].point_limit,
        required: self.state.data[date].inputs[info].required,
        max_points: self.state.data[date].inputs[info].max_points,
        min_points: self.state.data[date].inputs[info].min_points,
        aps_day: self.state.data[date].inputs[info].aps_day,
        hours_day: self.state.data[date].inputs[info].hours_day,
        nocturnal_extra_points: self.state.data[date].inputs[info].nocturnal_extra_points,
        reduction_points: self.state.data[date].inputs[info].reduction_points,
        extra_hours: self.state.data[date].inputs[info].extra_hours,
        automation_type: self.state.data[date].inputs[info].automation_type,
        limit_extra_hours_week: self.state.data[date].inputs[info].limit_extra_hours_week,
        limit_extra_hours_month: self.state.data[date].inputs[info].limit_extra_hours_month,
        day_limit_extra_hours_week: self.state.data[date].inputs[info].day_limit_extra_hours_week,
        day_limit_extra_hours_month: self.state.data[date].inputs[info].day_limit_extra_hours_month,
        }
        data_temp_inputs.push(change);
      });
      data_temp[date].inputs = data_temp_inputs;
    });
    this.setState({data: data_temp});
  }

  handleFatigueChange (name, date_str, event) {
    var change = {};
    var data_temp = [];
    var data_temp_inputs = [];
    var self = this;
    Object.keys(self.state.data).map(function(date) {
      data_temp[date] = {};
      data_temp[date].date_str = self.state.data[date].date_str;
      data_temp[date].quantity_points = self.state.data[date].quantity_points;
      data_temp[date].day_off = self.state.data[date].day_off;
      data_temp_inputs = [];
      Object.keys(self.state.data[date].inputs).map(function(info) {
        if(self.state.data[date].inputs[info].id === name && self.state.data[date].date_str === date_str) {
          change = {
            value: event.target.value,
            id: self.state.data[date].inputs[info].id,
            name: self.state.data[date].inputs[info].name,
            type_str: self.state.data[date].inputs[info].type_str,
            type: self.state.data[date].inputs[info].type,
            fatigue_options: self.state.data[date].inputs[info].fatigue_options,
            operator: self.state.data[date].inputs[info].operator,
            hour_points: self.state.data[date].inputs[info].hour_points,
            quantity_points: self.state.data[date].inputs[info].quantity_points,
            point_limit: self.state.data[date].inputs[info].point_limit,
            required: self.state.data[date].inputs[info].required,
            max_points: self.state.data[date].inputs[info].max_points,
            min_points: self.state.data[date].inputs[info].min_points,
            aps_day: self.state.data[date].inputs[info].aps_day,
            hours_day: self.state.data[date].inputs[info].hours_day,
            nocturnal_extra_points: self.state.data[date].inputs[info].nocturnal_extra_points,
            reduction_points: self.state.data[date].inputs[info].reduction_points,
            extra_hours: self.state.data[date].inputs[info].extra_hours,
            automation_type: self.state.data[date].inputs[info].automation_type,
            limit_extra_hours_week: self.state.data[date].inputs[info].limit_extra_hours_week,
            limit_extra_hours_month: self.state.data[date].inputs[info].limit_extra_hours_month,
            day_limit_extra_hours_week: self.state.data[date].inputs[info].day_limit_extra_hours_week,
            day_limit_extra_hours_month: self.state.data[date].inputs[info].day_limit_extra_hours_month,
          };

        } else {
          change = {
            value: self.state.data[date].inputs[info].value,
            id: self.state.data[date].inputs[info].id,
            name: self.state.data[date].inputs[info].name,
            type_str: self.state.data[date].inputs[info].type_str,
            type: self.state.data[date].inputs[info].type,
            fatigue_options: self.state.data[date].inputs[info].fatigue_options,
            operator: self.state.data[date].inputs[info].operator,
            hour_points: self.state.data[date].inputs[info].hour_points,
            quantity_points: self.state.data[date].inputs[info].quantity_points,
            point_limit: self.state.data[date].inputs[info].point_limit,
            required: self.state.data[date].inputs[info].required,
            max_points: self.state.data[date].inputs[info].max_points,
            min_points: self.state.data[date].inputs[info].min_points,
            aps_day: self.state.data[date].inputs[info].aps_day,
            hours_day: self.state.data[date].inputs[info].hours_day,
            nocturnal_extra_points: self.state.data[date].inputs[info].nocturnal_extra_points,
            reduction_points: self.state.data[date].inputs[info].reduction_points,
            extra_hours: self.state.data[date].inputs[info].extra_hours,
            automation_type: self.state.data[date].inputs[info].automation_type,
            limit_extra_hours_week: self.state.data[date].inputs[info].limit_extra_hours_week,
            limit_extra_hours_month: self.state.data[date].inputs[info].limit_extra_hours_month,
            day_limit_extra_hours_week: self.state.data[date].inputs[info].day_limit_extra_hours_week,
            day_limit_extra_hours_month: self.state.data[date].inputs[info].day_limit_extra_hours_month,
          };
        }
        data_temp_inputs.push(change);
      });
      data_temp[date].inputs = data_temp_inputs;
    });
    this.setState({data: data_temp});
  }
  handleSelectFatigueChange(name, date_str, event) {
    var change = {};
    var data_temp = [];
    var data_temp_inputs = [];
    var self = this;
    Object.keys(self.state.data).map(function(date) {
      data_temp[date] = {};
      data_temp[date].date_str = self.state.data[date].date_str;
      data_temp[date].quantity_points = self.state.data[date].quantity_points;
      data_temp[date].day_off = self.state.data[date].day_off;
      data_temp_inputs = [];
      Object.keys(self.state.data[date].inputs).map(function(info) {
        if(self.state.data[date].inputs[info].id === name && self.state.data[date].date_str === date_str) {
          change = {
            value: event.value,
            id: self.state.data[date].inputs[info].id,
            name: self.state.data[date].inputs[info].name,
            type_str: self.state.data[date].inputs[info].type_str,
            type: self.state.data[date].inputs[info].type,
            fatigue_options: self.state.data[date].inputs[info].fatigue_options,
            operator: self.state.data[date].inputs[info].operator,
            hour_points: self.state.data[date].inputs[info].hour_points,
            quantity_points: self.state.data[date].inputs[info].quantity_points,
            point_limit: self.state.data[date].inputs[info].point_limit,
            required: self.state.data[date].inputs[info].required,
            max_points: self.state.data[date].inputs[info].max_points,
            min_points: self.state.data[date].inputs[info].min_points,
            aps_day: self.state.data[date].inputs[info].aps_day,
            hours_day: self.state.data[date].inputs[info].hours_day,
            nocturnal_extra_points: self.state.data[date].inputs[info].nocturnal_extra_points,
            reduction_points: self.state.data[date].inputs[info].reduction_points,
            extra_hours: self.state.data[date].inputs[info].extra_hours,
            automation_type: self.state.data[date].inputs[info].automation_type,
            limit_extra_hours_week: self.state.data[date].inputs[info].limit_extra_hours_week,
            limit_extra_hours_month: self.state.data[date].inputs[info].limit_extra_hours_month,
            day_limit_extra_hours_week: self.state.data[date].inputs[info].day_limit_extra_hours_week,
            day_limit_extra_hours_month: self.state.data[date].inputs[info].day_limit_extra_hours_month,
          };

        } else {
          change = {
            value: self.state.data[date].inputs[info].value,
            id: self.state.data[date].inputs[info].id,
            name: self.state.data[date].inputs[info].name,
            type_str: self.state.data[date].inputs[info].type_str,
            type: self.state.data[date].inputs[info].type,
            fatigue_options: self.state.data[date].inputs[info].fatigue_options,
            operator: self.state.data[date].inputs[info].operator,
            hour_points: self.state.data[date].inputs[info].hour_points,
            quantity_points: self.state.data[date].inputs[info].quantity_points,
            point_limit: self.state.data[date].inputs[info].point_limit,
            required: self.state.data[date].inputs[info].required,
            max_points: self.state.data[date].inputs[info].max_points,
            min_points: self.state.data[date].inputs[info].min_points,
            aps_day: self.state.data[date].inputs[info].aps_day,
            hours_day: self.state.data[date].inputs[info].hours_day,
            nocturnal_extra_points: self.state.data[date].inputs[info].nocturnal_extra_points,
            reduction_points: self.state.data[date].inputs[info].reduction_points,
            extra_hours: self.state.data[date].inputs[info].extra_hours,
            automation_type: self.state.data[date].inputs[info].automation_type,
            limit_extra_hours_week: self.state.data[date].inputs[info].limit_extra_hours_week,
            limit_extra_hours_month: self.state.data[date].inputs[info].limit_extra_hours_month,
            day_limit_extra_hours_week: self.state.data[date].inputs[info].day_limit_extra_hours_week,
            day_limit_extra_hours_month: self.state.data[date].inputs[info].day_limit_extra_hours_month,
          };
        }
        data_temp_inputs.push(change);
      });
      data_temp[date].inputs = data_temp_inputs;
    });
    this.setState({data: data_temp});
  }


  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }
  handleSelectChangeApplicability(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/relatorios-de-fadiga/listagens';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({
            applicabilities_list: responseJson.data.applicabilities_list,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); /* Overlay */
    });
  }

  copytoNextDate (event) {
    //Data que ta sendo copiado os dados
    var this_date = event.currentTarget.value;
    var self = this;
    this.handleAlert('', '', 'open');
    var copy_data = [];
    var day_off = false;
    //Itero todas as datas afim de achar qual está sendo copiada
    Object.keys(self.state.data).map(function(date) {
      if(self.state.data[date].date_str === this_date) {
        day_off = self.state.data[date].day_off;
        Object.keys(self.state.data[date].inputs).map(function(info) {
          copy_data[info] = {};
          copy_data[info].value = self.state.data[date].inputs[info].value;
          copy_data[info].id = self.state.data[date].inputs[info].id;
        });
      }
    });

    var change = {};
    var data_temp = [];
    var data_temp_inputs = [];
    Object.keys(self.state.data).map(function(date) {
      data_temp[date] = {};
      data_temp[date].date_str = self.state.data[date].date_str;
      data_temp[date].quantity_points = self.state.data[date].quantity_points;
      data_temp[date].day_off = day_off;
      data_temp_inputs = [];
      Object.keys(self.state.data[date].inputs).map(function(info) {
        Object.keys(copy_data).map(function(k) {
          if(self.state.data[date].date_str > this_date) {
            if(self.state.data[date].inputs[info].id === copy_data[k].id) {
              change = {
                value: copy_data[k].value,
                id: self.state.data[date].inputs[info].id,
                name: self.state.data[date].inputs[info].name,
                type_str: self.state.data[date].inputs[info].type_str,
                day_off: self.state.data[date].inputs[info].day_off,
                type: self.state.data[date].inputs[info].type,
                fatigue_options: self.state.data[date].inputs[info].fatigue_options,
                operator: self.state.data[date].inputs[info].operator,
                hour_points: self.state.data[date].inputs[info].hour_points,
                quantity_points: self.state.data[date].inputs[info].quantity_points,
                point_limit: self.state.data[date].inputs[info].point_limit,
                  required: self.state.data[date].inputs[info].required,
                max_points: self.state.data[date].inputs[info].max_points,
                min_points: self.state.data[date].inputs[info].min_points,
                aps_day: self.state.data[date].inputs[info].aps_day,
                hours_day: self.state.data[date].inputs[info].hours_day,
                nocturnal_extra_points: self.state.data[date].inputs[info].nocturnal_extra_points,
                reduction_points: self.state.data[date].inputs[info].reduction_points,
                extra_hours: self.state.data[date].inputs[info].extra_hours,
                automation_type: self.state.data[date].inputs[info].automation_type,
                limit_extra_hours_week: self.state.data[date].inputs[info].limit_extra_hours_week,
                limit_extra_hours_month: self.state.data[date].inputs[info].limit_extra_hours_month,
                day_limit_extra_hours_week: self.state.data[date].inputs[info].day_limit_extra_hours_week,
                day_limit_extra_hours_month: self.state.data[date].inputs[info].day_limit_extra_hours_month,

              };
            }
          } else {
            change = {
              value: self.state.data[date].inputs[info].value,
              id: self.state.data[date].inputs[info].id,
              name: self.state.data[date].inputs[info].name,
              type_str: self.state.data[date].inputs[info].type_str,
              day_off: self.state.data[date].inputs[info].day_off,
              type: self.state.data[date].inputs[info].type,
              fatigue_options: self.state.data[date].inputs[info].fatigue_options,
              operator: self.state.data[date].inputs[info].operator,
              hour_points: self.state.data[date].inputs[info].hour_points,
              quantity_points: self.state.data[date].inputs[info].quantity_points,
              point_limit: self.state.data[date].inputs[info].point_limit,
              required: self.state.data[date].inputs[info].required,
              max_points: self.state.data[date].inputs[info].max_points,
              min_points: self.state.data[date].inputs[info].min_points,
              aps_day: self.state.data[date].inputs[info].aps_day,
              hours_day: self.state.data[date].inputs[info].hours_day,
              nocturnal_extra_points: self.state.data[date].inputs[info].nocturnal_extra_points,
              reduction_points: self.state.data[date].inputs[info].reduction_points,
              extra_hours: self.state.data[date].inputs[info].extra_hours,
              automation_type: self.state.data[date].inputs[info].automation_type,
              limit_extra_hours_week: self.state.data[date].inputs[info].limit_extra_hours_week,
              limit_extra_hours_month: self.state.data[date].inputs[info].limit_extra_hours_month,
              day_limit_extra_hours_week: self.state.data[date].inputs[info].day_limit_extra_hours_week,
              day_limit_extra_hours_month: self.state.data[date].inputs[info].day_limit_extra_hours_month,
            };
          }
        });
        data_temp_inputs.push(change);
      });
      data_temp[date].inputs = data_temp_inputs;
    });
    setTimeout(function(){
      self.setState({overlay: {message: "", type: "", status: 'closed'}, data: data_temp});
    }, 1000);

  }

  add(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      date_start_str: this.state.date_start_str,
      date_finish_str: this.state.date_finish_str,
      quantity_points: this.state.quantity_points,
      applicability_id: this.state.applicability_id,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/gerar/simulador/relatorios-de-fadiga', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data, simulated: 1});
        }
        self.setState({overlay: {message: "", type: "", status: 'closed'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  addFatigue(event) {
    event.preventDefault();
    //this.handleAlert('', '', 'open');
    var email = localStorage.getItem("data");
    var cid = localStorage.getItem("cid");
    var storage = JSON.parse(cid);
    var datasave = {
      data: this.state.data,
      applicability_id: this.state.applicability_id,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/simular/relatorios-de-fadiga', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data_reports: responseJson.data, modal: true});
        }
        self.setState({overlay: {message: "", type: "", status: 'closed'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    var e_key = 0;
    return (
<div>
  <Topo promptInstall={this.props.promptInstall}></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">

      <h3 className="page-title pull-left">{this.locale.RelatoriosDeFadiga.SimuladorDeRelatoriosDeFadiga.titulo}</h3>
      <Link to="/parametros-de-fadiga" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.RelatoriosDeFadiga.SimuladorDeRelatoriosDeFadiga.formulario.DataInicial}:</label>
              <InputMask value={this.state.date_start_str} required maskChar={null} name="date_start_str" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start_str')} placeholder="" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.RelatoriosDeFadiga.SimuladorDeRelatoriosDeFadiga.formulario.DataFinal}:</label>
              <InputMask value={this.state.date_finish_str} required maskChar={null} name="date_finish_str" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish_str')} placeholder="" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.RelatoriosDeFadiga.SimuladorDeRelatoriosDeFadiga.formulario.AplicabilidadeTipoDeColaborador}:</label>
              <Select
                className="form-field-name"
                name="applicability_id"
                value={this.state.applicability_id}
                searchable={true}
                placeholder={this.locale.RelatoriosDeFadiga.SimuladorDeRelatoriosDeFadiga.formulario.placeholder.SelecionarAplicabilidade}
                onChange={this.handleSelectChangeApplicability.bind(this, 'applicability_id')}
                options={this.state.applicabilities_list}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.RelatoriosDeFadiga.SimuladorDeRelatoriosDeFadiga.formulario.QuantidadeDePontos}:</label>
              <input type="text" name="quantity_points" className="form-control" placeholder="" value={this.state.quantity_points} onChange={this.handleChange.bind(this, 'quantity_points')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.RelatoriosDeFadiga.SimuladorDeRelatoriosDeFadiga.formulario.botaoGerarSimulacaoDeRelatoriosDeFadiga}</button>
          </div>
        </div>
      </form>
      <hr/>
      {self.state.simulated === 0 ? ""
        :
        <Tabs activeKey={this.state.key} onSelect={this.handleNavTab.bind(this, 'key')} id="controlled-tab-example">
          {Object.keys(self.state.data).map(function(k) {
            {e_key++;}
            return (
              <Tab eventKey={e_key} title={self.state.data[k].date_str}>
                <button onClick={self.addFatigue} className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {self.locale.RelatoriosDeFadiga.SimuladorDeRelatoriosDeFadiga.tabDatas.botaoGerarRelatoriosDeFadiga}</button>
                <button className="btn btn-lg btn-info btn-block" value={self.state.data[k].date_str} onClick={self.copytoNextDate}><i className="fa fa-fw fa-chevron-right"></i> {self.locale.RelatoriosDeFadiga.SimuladorDeRelatoriosDeFadiga.tabDatas.botaoCopiarParaProximasDatas}</button>
                <hr/>
                <form>
                  <div className="form-group">
                    <label>{self.locale.RelatoriosDeFadiga.SimuladorDeRelatoriosDeFadiga.tabDatas.formulario.MarcarComoFolga}??</label>
                    <br/>
                    <Toggle
                      checked={self.state.data[k].day_off}
                      aria-label='No label tag'
                      name="day_off"
                      onChange={self.handleToggleChange.bind(self, self.state.data[k].date_str)} />
                  </div>
                  <div className="form-group">
                    <label>{self.locale.RelatoriosDeFadiga.SimuladorDeRelatoriosDeFadiga.tabDatas.formulario.Data}:</label>
                    <InputMask value={self.state.data[k].date_str} required maskChar={null} name="date_str" disabled="disabled" mask="99/99/9999" className="form-control" onChange={self.handleChangeData.bind(self, 'date_str')} placeholder="" />
                  </div>
                  {Object.keys(self.state.data[k].inputs).map(function(ki) {
                    return (
                      <div className="form-group">
                        <label>{self.state.data[k].inputs[ki].name + " - " + self.state.data[k].inputs[ki].type_str}</label>
                        {(self.state.data[k].inputs[ki].type === 'options') ?
                          <Select
                            className="form-field-name"
                            name="type"
                            value={self.state.data[k].inputs[ki].value}
                            searchable={true}
                            placeholder={self.locale.RelatoriosDeFadiga.SimuladorDeRelatoriosDeFadiga.tabDatas.formulario.placeholder.SelecionarOpcao}
                            onChange={self.handleSelectFatigueChange.bind(self, self.state.data[k].inputs[ki].id, self.state.data[k].date_str)}
                            options={self.state.data[k].inputs[ki]['fatigue_options']}
                          />
                          : (self.state.data[k].inputs[ki].type === 'hour') ?
                          <InputMask value={self.state.data[k].inputs[ki].value} maskChar={null} name={"fatigue_reason_" + self.state.data[k].inputs[ki].id} mask="99:99" className="form-control" onChange={self.handleFatigueChange.bind(self, self.state.data[k].inputs[ki].id, self.state.data[k].date_str)} placeholder={self.locale.RelatoriosDeFadiga.SimuladorDeRelatoriosDeFadiga.tabDatas.formulario.placeholder.Horas} />
                          :
                          <input type="text" name={"fatigue_reason_" + self.state.data[k].inputs[ki].id} className={"form-control"} placeholder={self.locale.RelatoriosDeFadiga.SimuladorDeRelatoriosDeFadiga.tabDatas.formulario.placeholder.Quantidade} value={self.state.data[k].inputs[ki].value} onChange={self.handleFatigueChange.bind(self, self.state.data[k].inputs[ki].id, self.state.data[k].date_str)} />
                        }
                      </div>
                    );
                  })}
                </form>
              </Tab>
            );
          })}

        </Tabs>
      }
      <Modal show={this.state.modal} bsSize={'large'} aria-labelledby="contained-modal-title-lg">
        <Modal.Header>
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
          <i className="fa fa-fw fa-close"></i></button>
          <div className="clearfix"></div>
        </Modal.Header>
        <Modal.Body>
          <table className="table table-bordered table-stripped">
            <thead>
              <tr>
                <th>
                  {this.locale.RelatoriosDeFadiga.SimuladorDeRelatoriosDeFadiga.tabela.Data}
                </th>
                <th>
                  {this.locale.RelatoriosDeFadiga.SimuladorDeRelatoriosDeFadiga.tabela.Diaria}
                </th>
                <th>
                  {this.locale.RelatoriosDeFadiga.SimuladorDeRelatoriosDeFadiga.tabela.Acumulada}
                </th>
              </tr>
            </thead>
            <tbody id="frotas">
            {self.state.data_reports !== null ?
              Object.keys(self.state.data_reports.data_reports).map(function(k) {
                return (
                  <tr>
                    <td>
                      {self.state.data_reports.data_reports[k].date_str}
                    </td>
                    <td style={{background: self.state.data_reports.data_reports[k].report_points_background}}>
                      {self.state.data_reports.data_reports[k].report_points}
                    </td>
                    <td style={{background: self.state.data_reports.data_reports[k].actual_points_background}}>
                      {self.state.data_reports.data_reports[k].actual_points}
                    </td>
                  </tr>
                );
              })
            : ""}
            </tbody>
          </table>
          {self.state.data_reports !== null ?
              <div>
                <div className="hidden-sm hidden-xs">
                  <LineChart width={890} height={400} data={self.state.data_reports.dates}
                        margin={{top: 5, right: 30, left: 20, bottom: 5}}>
                    <XAxis dataKey="name"/>
                    <YAxis/>
                    <CartesianGrid strokeDasharray="3 3"/>
                    <Tooltip/>
                    <Legend />
                    {Object.keys(self.state.data_reports.names).map(function(k) {
                      return (
                       <Line type="monotone" dataKey={self.state.data_reports.names[k].name} stroke={self.state.data_reports.names[k].color} activeDot={{r: 8}}/>
                      );
                    })}
                  </LineChart>
                </div>
                <div className="visible-sm-inline-block">
                  <LineChart width={690} height={300} data={self.state.data_reports.dates}
                        margin={{top: 5, right: 30, left: 20, bottom: 5}}>
                    <XAxis dataKey="name"/>
                    <YAxis/>
                    <CartesianGrid strokeDasharray="3 3"/>
                    <Tooltip/>
                    <Legend />
                    {Object.keys(self.state.data_reports.names).map(function(k) {
                      return (
                       <Line type="monotone" dataKey={self.state.data_reports.names[k].name} stroke={self.state.data_reports.names[k].color} activeDot={{r: 8}}/>
                      );
                    })}
                  </LineChart>
                </div>
                <div className="visible-xs-inline-block">
                  <LineChart width={280} height={400} data={self.state.data_reports.dates}
                        margin={{top: 5, right: 30, left: 20, bottom: 5}}>
                    <XAxis dataKey="name"/>
                    <YAxis/>
                    <CartesianGrid strokeDasharray="3 3"/>
                    <Tooltip/>
                    <Legend />
                    {Object.keys(self.state.data_reports.names).map(function(k) {
                      return (
                       <Line type="monotone" dataKey={self.state.data_reports.names[k].name} stroke={self.state.data_reports.names[k].color} activeDot={{r: 8}}/>
                      );
                    })}
                  </LineChart>
                </div>
              </div>
          : ""}
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
          <i className="fa fa-fw fa-close"></i></button>
        </Modal.Footer>
      </Modal>
    </div>
  </div>
</div>
    );
  }
}

export default FatigueAdd;



// WEBPACK FOOTER //
// ./src/Components/StaffRfmsReport/SimulatorStaffRfmsReport.js